import { ticker } from '@/api/server/common/ticker';
import ConnectWallet from '@/component/ConnectWallet';
import Pools from '@/component/pools/Pools';
import NoticeDialog from '@/component/mui/NoticeDialog';
import { useContractPool } from '@/hooks/use-contract-pool';
import { useWeb3 } from '@/hooks/use-web3';
import { fiexdDecimal, NumWithComma } from '@/lib/BigNumbers';
import { COIN_NAME_SFL, TOTALFUNDRAISINGMULTIPLIEDPRICE } from '@/lib/common/name-space';
import { promiseAllSettled } from '@/lib/Promise';
import { useTickerStore } from '@/store/zustand/ticker';
import { Box } from '@mui/material';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';
// import { checkVersionOncePerDay } from '@/utils/versionCheck';

export default function PoolMain() {
  // const { web3authCall } = useWeb3();
  // const handleTicker = async () => {
  //   if (!web3authCall?.connected() || !web3authCall) {
  //     return;
  //   }
  //   await setCurrencyTicker(web3authCall);
  // };
  const [pools, setPools] = useState<string[]>([]);
  const { web3authCall } = useWeb3();
  const { contractPools, privates, isLoading, error } = useContractPool();
  const { setSymbolData } = useTickerStore();

  const [popup] = useState<boolean>(false);

  // // 버전 체크
  // useEffect(() => {
  //   checkVersionOncePerDay();
  // }, []);

  useEffect(() => {
    (async () => {
      setPools(contractPools);

      await setTotal(contractPools);
    })();
    return () => {};
  }, [contractPools]);

  useEffect(() => {
    if (privates === null) {
      return;
    }
    (async () => {
      await setPrivateToken();
    })();
    return () => {};
  }, [privates, web3authCall]);

  useEffect(() => {
    (async () => {
      const re = await ticker({ symbol: COIN_NAME_SFL, amount: '1' });
      setSymbolData(COIN_NAME_SFL, {
        usdt: re.data.latest_price,
      });
    })();
    return () => {};
  }, []);

  const setTotal = async (pools: string[]) => {
    const arr = [];
    for (const iter of pools) {
      arr.push(() => web3authCall?.callStaking(TOTALFUNDRAISINGMULTIPLIEDPRICE, iter));
    }
    const arrUsdt = await promiseAllSettled(arr);
    const re = arrUsdt.reduce((acc, item) => {
      return BigNumber(acc).plus(item);
    }, BigNumber(0));
    const usdt = re ? NumWithComma(fiexdDecimal(re)) : '0';
    return usdt;
  };
  const setPrivateToken = async () => {
    if (privates === null) {
      return;
    }
    await web3authCall?.getRpc().addContract(privates);
  };

  // 로딩 중이거나 에러가 있는 경우 처리
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <div>로딩 중...</div>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          color: 'error.main',
        }}
      >
        <div>에러가 발생했습니다: {error}</div>
      </Box>
    );
  }

  return (
    <>
      {/* 공지사항 다이얼로그 */}
      <NoticeDialog open={popup} />

      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <ConnectWallet />
        {/* 업데이트 중입니다. */}
        <Pools pools={pools} />
      </Box>
    </>
  );
}
